import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=7a6c76ba"
import script from "./Load.vue?vue&type=script&lang=ts"
export * from "./Load.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports